import { type FC, type PropsWithChildren } from 'react';

import styles from './GalleryPaginationFractionWrapper.css';

/**
 * Обертка над каунтером слайдов в галереи.
 * Нужна, чтобы спозиционировать каунтер по левому краю (сейчас он из коробки споциционирован по правому краю).
 */
export const GalleryPaginationFractionWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['wrapper']} data-testid="card-gallery.pagination">
      {children}
    </div>
  );
};
